var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 8.29749,
    stroke: "#F2994A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6002 9.05942L31.9432 17.26L31.9438 17.2614C31.9522 17.2834 32.2829 18.1621 31.2389 17.261C30.1817 16.3486 28.0673 16.5311 28.0673 16.5311C26.5264 16.6641 24.4241 17.3786 23.3971 17.7564C23.0925 17.8684 23.0119 18.2335 23.2366 18.4675C24.3044 19.5795 26.0363 21.7451 20.5752 23.5895L14.3056 26.0426C12.3246 26.5556 9.89726 26.4874 10.2865 23.2723C10.3269 22.9383 10.0456 22.643 9.71529 22.7069C8.34218 22.9726 5.38432 23.6071 5.24936 24.1667C5.07332 24.8967 4.68167 24.6855 4.36847 23.8018C4.07498 22.9736 4.26607 21.6715 4.89702 22.3419C5.52797 23.0123 20.6676 15.8011 20.6676 15.8011C20.7459 15.7616 20.8268 15.7207 20.9102 15.6786C22.7684 14.7407 25.8223 13.1993 26.8341 12.1514C26.8341 12.1514 28.2436 11.0566 28.2436 9.77917C28.2436 8.60096 28.5434 8.97522 28.59 9.04044C28.5942 9.0464 28.5974 9.05264 28.6002 9.05942ZM17.2424 20.6378C13.7832 21.8531 11.7531 22.5664 11.5643 23.5668C11.3259 24.7011 12.5277 25.6152 13.5708 25.134C15.8858 24.066 18.5374 23.0455 20.5207 22.2822C21.2968 21.9835 21.9707 21.7241 22.4819 21.5168C23.1096 21.2622 23.3008 20.6262 23.001 20.021C22.6458 19.3042 21.8116 18.9832 21.0607 19.2641C19.646 19.7934 18.3685 20.2422 17.2424 20.6378Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.486b8457bcb7d508ddea56afcb713835.svg";
export { ForwardRef as ReactComponent };